import _ from "lodash";
import client from "lib/apolloClient/client";

import { generateRandomId } from "Utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

import {
  createPointAssessmentSetMutation,
  updatePointAssessmentSetMutation,
  deletePointAssessmentSetMutation,
} from "ScoreCategories/modules/ScoreCategoriesMutation";

import {
  getOrganizationPointSetQuery,
  getSubjectDetailsQuery,
} from "ScoreCategories/modules/ScoreCategoriesQueries";

export const NAME = "gradeScales";
export const UPDATE_SELECTED_TAB = `UPDATE_SELECTED_TAB ${NAME}`;

export const GRADE_SCALE_INITIAL_STATE = {
  id: generateRandomId(),
  label: "Overall grade",
  fieldValues: [
    {
      id: generateRandomId(),
      label: "",
      percentageWeight: "",
      scoreValuesId: generateRandomId(),
    },
    {
      id: generateRandomId(),
      label: "",
      percentageWeight: "0",
      scoreValuesId: generateRandomId(),
    },
  ],
};

export const createGradeScale = ({
  input,
  pointSetVariables,
  isCategoryGradeScale,
  scoreBasedAssessmentVariables,
}) => {
  return async dispatch => {
    try {
      const refetchQueries = [];

      if (pointSetVariables) {
        refetchQueries.push({
          query: getOrganizationPointSetQuery,
          variables: pointSetVariables,
        });
      }

      if (scoreBasedAssessmentVariables) {
        refetchQueries.push({
          query: getSubjectDetailsQuery,
          variables: scoreBasedAssessmentVariables,
        });
      }

      const response = await client.mutate({
        mutation: createPointAssessmentSetMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      const toastMsg = isCategoryGradeScale
        ? "toastMsgs:category_grade_boundary_successfully_created"
        : "toastMsgs:grade_boundary_successfully_updated";

      dispatch(
        setToastMsg({
          msg: toastMsg,
          type: "success",
        })
      );

      return _.first(
        _.get(response, "data.planner.createPointAssessmentSet.response")
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateGradeScale = ({
  input,
  pointSetVariables,
  isCategoryGradeScale,
}) => {
  return async dispatch => {
    try {
      const refetchQueries = [];

      if (pointSetVariables) {
        refetchQueries.push({
          query: getOrganizationPointSetQuery,
          variables: pointSetVariables,
        });
      }

      const response = await client.mutate({
        mutation: updatePointAssessmentSetMutation,
        variables: { input },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      const toastMsg = isCategoryGradeScale
        ? "toastMsgs:category_grade_boundary_successfully_updated"
        : "toastMsgs:grade_boundary_successfully_updated";

      dispatch(
        setToastMsg({
          msg: toastMsg,
          type: "success",
        })
      );

      return _.first(
        _.get(response, "data.planner.updatePointAssessmentSet.response")
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const deleteGradeScale = ({
  gradeScaleSetId,
  pointSetVariables,
  scoreBasedAssessmentVariables,
}) => {
  const refetchQueries = [
    {
      query: getSubjectDetailsQuery,
      variables: scoreBasedAssessmentVariables,
    },
  ];

  if (!_.isEmpty(pointSetVariables)) {
    refetchQueries.push({
      query: getOrganizationPointSetQuery,
      variables: pointSetVariables,
    });
  }

  return async (dispatch, getState) => {
    return await client.mutate({
      mutation: deletePointAssessmentSetMutation,
      variables: {
        input: {
          ids: [gradeScaleSetId],
        },
      },
      awaitRefetchQueries: true,
      refetchQueries,
    });
  };
};

export const updateSelectedTab = payload => {
  return {
    type: UPDATE_SELECTED_TAB,
    payload,
  };
};

const REDUCER_HANDLERS = {
  [UPDATE_SELECTED_TAB]: (state, action) => {
    return {
      ...state,
      selectedTab: action.payload,
    };
  },
};

const initialState = {
  selectedTab: "DEFAULT_GRADE_SCALE",
};

export default function reducer(state = initialState, action = {}) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
